/* eslint-disable import/no-extraneous-dependencies */
// Copyright (c) 2016 Deere & Company

import IntlMessageFormat from 'intl-messageformat';
import { getMessages } from '@deere/cps-it.warranty-i18n';

export const translate = (messageId, args = {}, primaryLanguageKey = 'EN') => {

    const locale = primaryLanguageKey;

    const messageData = getMessages()[locale][messageId];

    const messageToTranslate = messageData || messageId;

    const message = new IntlMessageFormat(messageToTranslate, locale);

    return message.format(args);

};
